import axios, { AxiosError, AxiosResponse } from 'axios';
import { AbstractModule, isAbstractModule } from 'Models';
import { Pagination } from 'Requests/Pagination';
import { Collection } from 'Requests/Collection';
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { ErrorResponse, Uuid } from 'ValueObjects';
import Qs from 'qs';
import { Filterable } from 'Requests/Filterable';
import { QueryInvalidator } from 'Requests/QueryInvalidator';

export type ModulesByConnectionIdRequestProps = Pagination &
  Filterable & {
    connectionId: Uuid;
  };

type Response = AxiosResponse<Collection<AbstractModule>>;

export const ModulesByConnectionIdRequest = async ({
  connectionId,
  ...params
}: ModulesByConnectionIdRequestProps): Promise<Response> =>
  axios.get(`api/${connectionId}/modules`, {
    params: { ...params },
    paramsSerializer: {
      encode: (param) => Qs.parse(param),
      serialize: (param) => Qs.stringify(param, { arrayFormat: 'brackets' }),
    },
  });

export const useModulesByConnectionIdRequest = (
  request: ModulesByConnectionIdRequestProps,
  options: UseQueryOptions<Response, AxiosError<ErrorResponse>, Response> = {}
): UseQueryResult<Response, AxiosError<ErrorResponse>> =>
  useQuery<Response, AxiosError<ErrorResponse>, Response>({
    ...options,
    queryFn: async () => ModulesByConnectionIdRequest(request),
    queryKey: ['modules', 'list', ...Object.values(request)],
  });

export const ModulesByConnectionIdRequestInvalidator: QueryInvalidator = (
  data,
  queryClient
) => {
  if (isAbstractModule(data)) {
    queryClient.invalidateQueries(['modules', 'list']);
  }
};
